import { SentimentName } from 'v2/core/entities/fields';
import {
  OperatorSentimentNegative,
  OperatorSentimentNeutral,
  OperatorSentimentPositive,
} from './operators';

const operatorFromSentiment = (sentiment: SentimentName) => {
  switch (sentiment) {
    case SentimentName.POSITIVE:
      return OperatorSentimentPositive;
    case SentimentName.NEUTRAL:
      return OperatorSentimentNeutral;
    case SentimentName.NEGATIVE:
      return OperatorSentimentNegative;
  }
};

export default operatorFromSentiment;
